"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M2 22c0-.55.45-1 1-1 .87 0 1.73-.24 2.53-.7.29-.16.65-.17.94 0 1.59.9 3.48.9 5.06 0 .29-.16.65-.16.94 0 1.59.9 3.48.9 5.06 0 .29-.16.65-.16.94 0 .8.46 1.66.7 2.53.7.55 0 1 .45 1 1s-.45 1-1 1c-1.03 0-2.06-.25-3-.75-1.92 1.02-4.18 1-6.09-.05-1.79.87-3.92.98-5.58-.14C5.3 22.69 4.15 23 3 23c-.55 0-1-.45-1-1zM12 5.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9.47 12.95c-.42.14-.9.28-1.41.42-.53-.15-1.03-.43-1.45-.77-.35-.29-.87-.29-1.23 0-.66.53-1.48.9-2.38.9s-1.72-.37-2.39-.91c-.35-.28-.87-.28-1.22 0-.67.54-1.49.91-2.39.91s-1.72-.37-2.39-.91c-.35-.29-.87-.28-1.23 0-.43.35-.92.62-1.45.77-.51-.14-.98-.28-1.4-.42-.92-.3-.92-1.6 0-1.9 1.21-.39 2.79-.82 4.6-1.13l1.35-4.17c.31-.95 1.32-1.47 2.27-1.16.09.03.19.07.27.11l2.47 1.3 2.84-1.5 1.65-3.71-.36-.93c-.1-.25-.09-.52.02-.76l.74-1.68c.22-.51.82-.73 1.32-.51l1.37.61c.5.23.73.82.5 1.32l-.75 1.68c-.11.24-.31.43-.56.53l-.9.36-3.72 8.34c2.33.3 4.35.84 5.82 1.31.93.3.94 1.6.01 1.9zm-6.45-5.49-.59.31c-.58.31-1.28.31-1.86 0l-.81-.43-.71 2.17c.31 0 .63-.01.95-.01.71 0 1.4.03 2.07.08l.95-2.12z"
}), 'KayakingRounded');

exports.default = _default;